/**
 * How long an email body may get, counted in plain-text characters.
 *
 * The editor used to cap this at 2,000 with nothing on screen to say so, and
 * Tiptap's CharacterCount enforces a limit by dropping transactions: a paste
 * that does not fit is trimmed to size and, if it still does not fit, rejected
 * whole. To the rep that is Ctrl+V doing nothing at all. The same filter also
 * blocks `setContent`, so a generated email longer than the limit never
 * reached the editor either.
 *
 * 25,000 is about four pages of prose - past any email worth sending, and far
 * enough from a real draft that the counter below stays hidden in normal use.
 * It is not removed altogether because an unbounded paste (a PDF dumped into
 * the body) locks up ProseMirror, and a limit nobody reaches is cheap.
 */
export const EMAIL_BODY_CHARACTER_LIMIT = 25000;

/**
 * Fraction of the limit at which the counter appears.
 *
 * A counter pinned to the screen at all times is noise on a two-line reply.
 * The failure being designed against is silence at the ceiling, so the counter
 * only has to exist once the ceiling is in sight.
 */
export const CHARACTER_COUNT_VISIBLE_AT = 0.8;

/** Whether the character counter should be rendered at this length. */
export const shouldShowCharacterCount = (
  count: number,
  limit: number
): boolean => {
  if (limit <= 0) {
    return false;
  }

  return count >= limit * CHARACTER_COUNT_VISIBLE_AT;
};
